// extracted by mini-css-extract-plugin
export default {"container":"I_-z","productName":"J_-z","price":"K_-z","dimensions":"L_-z"};